import React, { forwardRef } from 'react'

import classNames from 'classnames'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'link' | 'edu'
  size?: 'sm' | 'lg'
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const defaultProps = {
  onClick: () => null,
}

const Button = forwardRef<HTMLButtonElement, Props>(
  ({ variant, size, children, onClick, className, ...props }: Props, ref) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={classNames(
        'btn',
        {
          'btn-primary': variant === 'primary' || !variant,
          'btn-secondary': variant === 'secondary',
          'btn-outline': variant === 'outline',
          'btn-edu': variant === 'edu',
          link: variant === 'link',
          'btn-small': size === 'sm',
          'btn-large': size === 'lg',
        },
        className
      )}
      {...props}>
      {children}
    </button>
  )
)
Button.defaultProps = defaultProps
export default Button
